import React, { useEffect, useState } from "react"

import {
  Col,
  Row,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Progress,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap"

import { connect } from "react-redux"
import { Link } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"

// Import images
import SubstrateImg from "../../assets/images/SubstrateImg.png"
import InoculationImg from "../../assets/images/inoculation.png"
import FruitingImg from "../../assets/images/fruiting1.png"
import HarvestingImg from "../../assets/images/harvesti.png"

import QR from "../../assets/images/qr.png"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const PROCESS_COLOR = '#e1b290';

const BagDetails = props => {
  document.title = "Process Sequence | My Urban Farms"

  const breadcrumbItems = []

  const [processList, setProcessList] = useState([]);

  useEffect(() => {
    props.setBreadcrumbItems("Process Sequence", breadcrumbItems)
    fetchFarms();
  }, [])

  const [processSlots, setProcessSlots] = useState(
    Array.from({ length: 10 }, (_, i) => ({
      slotNumber: i + 1,
      process: null
    }))
  );

  const adminKey = sessionStorage.getItem("pk_admin_key");

  const [farmList, setFarmList] = useState([])

  const [selectedFarmKey, setSelectedFarmKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  const fetchProcess = async (selectedFarmKey) => {
    try {
      // NOTE: Using a placeholder URL for testing
      const URL = `${process.env.REACT_APP_API_BASE_URL}/getAllProcess/process/`;
      const res = await axios.post(URL, { farmKey: selectedFarmKey });
      const resData = res.data;
      if (resData?.message?.success && Array.isArray(resData.message.data)) {
        // Map API data to the required structure for the component
        const mappedProcesses = resData.message.data.map(p => ({
          id: p.pk_process_key, // Used for identification
          title: p.process_name, // Display name
          bgColor: PROCESS_COLOR // Dynamic color
        }));
        setProcessList(mappedProcesses);
      } else {
        console.warn("Unexpected data format", resData);
      }
    } catch (err) {
      console.error("Failed to fetch process list:", err);
      toast.error("Failed to load processes");
    }
  };

  const fetchSavedSequence = async (selectedFarmKey) => {
    try {
      // NOTE: Using a placeholder URL for testing
      const URL = `${process.env.REACT_APP_API_BASE_URL}/getProcessSequence/process/`;
      const res = await axios.post(URL, { farmKey: selectedFarmKey });
      const resData = res.data;
      const seq = resData?.message?.data?.data || [];

      if (Array.isArray(seq)) {
        const initialSlots = Array.from({ length: 10 }, (_, i) => ({
          slotNumber: i + 1,
          process: null
        }));

        seq.forEach((s) => {
          const posIndex = s.process_position - 1;
          if (posIndex >= 0 && posIndex < initialSlots.length) {
            // Check if the processList is already available, otherwise this logic 
            // might run before processList is populated and only set the name/key
            initialSlots[posIndex].process = {
              id: s.fk_process_key,
              title: s.process_name,
              bgColor: PROCESS_COLOR
            };
          }
        });
        setProcessSlots(initialSlots);
      }
    } catch (err) {
      console.error("Failed to fetch sequence:", err);
    }
  };

  // Modal state
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedBag, setSelectedBag] = useState(null)
  const [newStage, setNewStage] = useState("")

  // Get stage image based on current stage
  const getStageImage = stage => {
    const images = {
      Substrate: SubstrateImg,
      Inoculation: InoculationImg,
      Fruiting: FruitingImg,
      Harvesting: HarvestingImg,
    }
    return images[stage] || FruitingImg
  }

  const getStatusColor = status => {
    return status === "Completed" ? "success" : "warning"
  }

  // State to track which dropdown is open - using bag id as key
  const [openDropdown, setOpenDropdown] = useState(null)

  const toggleDropdown = bagId => {
    setOpenDropdown(openDropdown === bagId ? null : bagId)
  }

  // Open change stage modal
  const openChangeStageModal = bag => {
    setSelectedBag(bag)
    setNewStage(bag.currentStage)
    setModalOpen(true)
    setOpenDropdown(null) // Close dropdown
  }

  // Handle stage change
  const handleStageChange = () => {
    if (!selectedBag || !newStage) return

    // Calculate new progress based on stage
    const stageProgress = {
      Substrate: 25,
      Inoculation: 50,
      Fruiting: 75,
      Harvesting: 100,
    }

    // Update bags state

    // Close modal
    setModalOpen(false)
    setSelectedBag(null)
    setNewStage("")
  }

  // Drag and drop state
  const [draggedProcess, setDraggedProcess] = useState(null);
  const [dragSource, setDragSource] = useState(null); // 'available' or slot index
  const [touchStartPos, setTouchStartPos] = useState(null);

  // Mouse drag handlers
  const handleDragStart = (e, process, source) => {
    setDraggedProcess(process);
    setDragSource(source);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  // Touch handlers for mobile - COMPLETELY REWRITTEN
  const handleTouchStart = (e, process, source) => {
    // Don't prevent default on touch start - allow touch to work naturally
    setDraggedProcess(process);
    setDragSource(source);
    const touch = e.touches[0];
    setTouchStartPos({ x: touch.clientX, y: touch.clientY });

    // Add visual feedback to the touched element
    e.currentTarget.style.opacity = '0.5';
    e.currentTarget.style.transform = 'scale(0.95)';
  };

  const handleTouchMove = (e) => {
    if (!draggedProcess) return;
    // Prevent scrolling while dragging
    e.preventDefault();
  };

  const handleTouchEnd = (e) => {
    if (!draggedProcess) return;

    e.preventDefault();
    const touch = e.changedTouches[0];

    // Get the element at the touch position
    const targetElement = document.elementFromPoint(touch.clientX, touch.clientY);

    // Reset visual feedback on the source element
    const allDraggables = document.querySelectorAll('[data-draggable="true"]');
    allDraggables.forEach(el => {
      el.style.opacity = '';
      el.style.transform = '';
    });

    if (!targetElement) {
      // Reset if no target found
      setDraggedProcess(null);
      setDragSource(null);
      setTouchStartPos(null);
      return;
    }

    // Find if we dropped on a slot container or inside it
    let slotContainer = targetElement.closest('[data-slot-index]');
    let availableZone = targetElement.closest('[data-available-zone]');

    if (availableZone) {
      // Dropped back to available zone
      if (dragSource !== 'available' && typeof dragSource === 'number') {
        const newSlots = [...processSlots];
        newSlots[dragSource].process = null;
        setProcessSlots(newSlots);
      }
    } else if (slotContainer) {
      // Dropped on a slot
      const targetSlotIndex = parseInt(slotContainer.getAttribute('data-slot-index'));

      if (dragSource !== targetSlotIndex) {
        performDrop(targetSlotIndex);
      }
    }

    // Reset drag state
    setDraggedProcess(null);
    setDragSource(null);
    setTouchStartPos(null);
  };

  const performDrop = (slotIndex) => {
    if (!draggedProcess) return;

    const newSlots = [...processSlots];

    if (dragSource === 'available') {
      // Moving from available to slot
      const existingIndex = newSlots.findIndex(slot => slot.process?.id === draggedProcess.id);
      if (existingIndex !== -1) {
        newSlots[existingIndex].process = null;
      }
      newSlots[slotIndex].process = draggedProcess;
    } else if (typeof dragSource === 'number') {
      // Swapping between slots
      const temp = newSlots[slotIndex].process;
      newSlots[slotIndex].process = newSlots[dragSource].process;
      newSlots[dragSource].process = temp;
    }

    setProcessSlots(newSlots);
  };

  const handleDropOnSlot = (e, slotIndex) => {
    e.preventDefault();
    performDrop(slotIndex);
    setDraggedProcess(null);
    setDragSource(null);
  };

  const handleDropOnAvailable = (e) => {
    e.preventDefault();
    if (!draggedProcess || dragSource === 'available') return;

    const newSlots = [...processSlots];
    if (typeof dragSource === 'number') {
      newSlots[dragSource].process = null;
      setProcessSlots(newSlots);
    }

    setDraggedProcess(null);
    setDragSource(null);
  };

  const handleResetSingleSlot = (slotIndex) => {
    const newSlots = [...processSlots];
    // Only reset if a process is currently in the slot
    if (newSlots[slotIndex].process) {
      newSlots[slotIndex].process = null;
      setProcessSlots(newSlots);
    }
    setOpenDropdown(null); // Close dropdown after action
  }

  const handleSaveOrder = async () => {
    const mapped = processSlots
      .map((slot, idx) => (slot.process ? { pk_process_key: slot.process.id, position: idx + 1 } : null))
      .filter(Boolean);

    if (mapped.length === 0) {
      toast.warning("Please assign at least one process!");
      return;
    }

    try {
      const URL = `${process.env.REACT_APP_API_BASE_URL}/updateProcessPositions/sequence/`;
      const res = await axios.post(
        URL,
        { positions: mapped, created_by: adminKey, fk_farm_key: selectedFarmKey }
      );

      const success = res.data?.message?.success;
      const msg = res.data?.message?.message || "Operation completed.";

      if (success) {
        toast.success(msg);
        // Re-fetch sequence to ensure UI reflects the saved state (optional, but good practice)
        fetchSavedSequence(selectedFarmKey);
      } else {
        toast.error(msg || "Failed to save positions!");
      }
    } catch (err) {
      console.error("Error saving positions:", err);
      toast.error("Error saving positions");
    }
  };

  const handleResetAll = () => {
    setProcessSlots(
      Array.from({ length: 10 }, (_, i) => ({
        slotNumber: i + 1,
        process: null
      }))
    );
  };

  const placedProcessIds = processSlots
    .map(slot => slot.process?.id)
    .filter(id => id !== null);

  // Filter available processes based on placed status
  const availableProcesses = processList.filter(process => !placedProcessIds.includes(process.id));

  const fetchFarms = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getAllFarms/farm/`
      );

      const resData = response.data;
      setIsLoading(false);

      if (resData.message?.success && Array.isArray(resData.message.data)) {
        setFarmList(resData.message.data);

        // Auto-select farm id=1 from list
        const defaultFarm = resData.message.data.find(f => f.pk_farm_id == 1);
        if (defaultFarm) {
          setSelectedFarmKey(defaultFarm.pk_farm_key);
        }
      } else {
        console.warn("Unexpected data format", resData);
        setFarmList([]);
      }
    } catch (error) {
      console.error("Failed to fetch:", error);
      setIsLoading(false);
      setFarmList([]);
      toast.error("Failed to fetch!", { autoClose: 3000 });
    }
  };

  useEffect(() => {
    if (selectedFarmKey) {
      fetchProcess(selectedFarmKey);
      fetchSavedSequence(selectedFarmKey);
    }
  }, [selectedFarmKey]);

  return (
    <React.Fragment>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <Breadcrumb />

        <div className="mt-2 me-3" style={{ minWidth: "250px" }}>
          <select
            className="form-select"
            value={selectedFarmKey}
            onChange={(e) => setSelectedFarmKey(e.target.value)}
          >
            <option value="">-- Select Farm --</option>
            {farmList.map((farm) => (
              <option key={farm.pk_farm_key} value={farm.pk_farm_key}>
                {farm.farm_name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Available Processes */}
      <div style={{ marginBottom: "32px" }}>
        <h3 style={{ fontSize: "16px", fontWeight: "500", marginBottom: "16px", color: "#4b5563" }}>
          Available Processes (Drag to positions below)
        </h3>
        <div
          style={{
            display: "flex",
            gap: "16px",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "2px dashed #cbd5e1",
            minHeight: "100px",
            flexWrap: "wrap"
          }}
          data-available-zone="true"
          onDragOver={handleDragOver}
          onDrop={handleDropOnAvailable}
        >
          {availableProcesses.map((process) => {
            const isPlaced = processSlots.some(slot => slot.process?.id === process.id);

            return (
              <div
                key={process.id}
                data-draggable="true"
                draggable={!isPlaced}
                onDragStart={(e) => !isPlaced && handleDragStart(e, process, 'available')}
                onTouchStart={(e) => !isPlaced && handleTouchStart(e, process, 'available')}
                onTouchMove={!isPlaced ? handleTouchMove : undefined}
                onTouchEnd={!isPlaced ? handleTouchEnd : undefined}
                style={{
                  backgroundColor: isPlaced ? "#d1d5db" : process.bgColor,
                  borderRadius: "8px",
                  padding: "20px 32px",
                  cursor: isPlaced ? "not-allowed" : "move",
                  color: isPlaced ? "#6b7280" : "#1f2431",
                  fontWeight: "600",
                  fontSize: "16px",
                  opacity: isPlaced ? 0.6 : 1,
                  transition: "all 0.2s",
                  userSelect: "none",
                  boxShadow: isPlaced ? "none" : "0 2px 4px rgba(0,0,0,0.1)",
                  touchAction: isPlaced ? "auto" : "none",
                  WebkitUserSelect: "none",
                  WebkitTouchCallout: "none",
                  pointerEvents: isPlaced ? "none" : "auto"
                }}
              >
                {process.title}
                {isPlaced && <div style={{ fontSize: "12px", marginTop: "4px", color: "#6b7280" }}>✓ Placed</div>}
              </div>
            );
          })}
        </div>
      </div>

      {/* Process Slots Grid */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: "16px",
        marginBottom: "32px",
        maxWidth: "100%"
      }}>
        {processSlots.map((slot, index) => (
          <div
            key={slot.slotNumber}
            data-slot-index={index}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDropOnSlot(e, index)}
            style={{
              backgroundColor: slot.process ? slot.process.bgColor : "#e1b2901c",
              borderRadius: "8px",
              padding: "24px",
              minHeight: "140px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              border: slot.process ? "2px solid #e1b290" : "2px dashed #cbd5e1",
              transition: "all 0.2s",
              position: "relative"
            }}
          >
            {slot.process && (
              <button
                onClick={() => handleResetSingleSlot(index)}
                style={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  cursor: 'pointer',
                  background: 'none', // Remove default button background
                  border: 'none',     // Remove default button border
                  padding: '0',       // Remove default button padding
                }}
                title="Reset Position" // Add a helpful tooltip
              >
                {/* Option 1: Using an Icon (recommended for better UI) */}
                <i
                  className="mdi mdi-undo-variant" // Change icon to something like undo or reset
                  style={{
                    fontSize: '18px',
                    color: '#dc3545' // Use the error color for emphasis
                  }}
                ></i>

                {/* Option 2: Using Text Button (Use only if space permits) */}
                {/* <span style={{ color: '#dc3545' }}>Reset Position</span> */}

              </button>
            )}
            {slot.process ? (
              <div
                data-draggable="true"
                draggable={true}
                onDragStart={(e) => handleDragStart(e, slot.process, index)}
                onTouchStart={(e) => handleTouchStart(e, slot.process, index)}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                style={{
                  cursor: "move",
                  textAlign: "center",
                  width: "100%",
                  touchAction: "none",
                  WebkitUserSelect: "none",
                  WebkitTouchCallout: "none",
                  transition: "opacity 0.2s, transform 0.2s"
                }}
              >
                <div style={{
                  fontSize: "14px",
                  color: "#1f2431",
                  marginBottom: "8px",
                  fontWeight: "500"
                }}>
                  Position {slot.slotNumber}
                </div>
                <div style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#1f2431"
                }}>
                  {slot.process.title}
                </div>
              </div>
            ) : (
              <div style={{
                fontSize: "32px",
                fontWeight: "bold",
                color: "#94a3b8"
              }}>
                {slot.slotNumber}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Action Buttons */}
      {/* Instructions */}


      <div style={{ display: "flex", gap: "12px" }}>
        <Button
          onClick={handleSaveOrder}
          type="button"
          color="primary"
          className="btn"
        >
          Save Order
        </Button>
        <button
          onClick={handleResetAll}
          type="button"
          color="light"
          className="btn btn-outline-primary"
        >
          Reset All
        </button>
      </div>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(BagDetails)